export default __webpack_public_path__ + "static/BoschSans-Bold-1c0fec11bf27edefeec11764f3a48407.ttf";